export default "<p>find-contract works!</p>\n"